import axios from "./axios"

function create(data) {
    return axios().post("/goods-receipts", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    });
}
function findByID(id) {
    return axios().get(`/goods-receipts/${id}`);      
}
function index(params) {
    params = {...params, limit: params.itemsPerPage, offset: (params.page -1) * params.itemsPerPage };
    return axios().get("/goods-receipts", { params })
}
function update(data) {
    return axios().put(`/goods-receipts/${data.id}`, data);
}

function remove(data) {
    return axios().delete(`/goods-receipts/${data.id}`);
}

function post(data) {
    return axios().put(`/goods-receipts/${data.id}/post`);
}

export default {
    create,
    findByID,
    index,
    update,
    remove,
    post
}